import { GET_BOOKING_DETAILS_ASIDE } from "../../../utils/constants"


const initialState = [];

function bookingdetailsAsideReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_BOOKING_DETAILS_ASIDE:
      return [...state, payload];
    
    default:
      return state;
  }
};

export default bookingdetailsAsideReducer;